import { StatusQuestionConfig, StatusResponseState } from '@gripp/shared-logic';
import { useEffect, useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Text } from 'react-native-paper';
import { Colors } from '../../../../../themes/colors';
import { ControlledTextInput, useFormContext } from '../../../../forms';
import { OpenEndedResponse } from '../../../status/types';
import {
  RoutineQuestionExecutionForm,
  RoutineQuestionExecutionFormProps,
} from '../types';

export const OpenEndedResponseExecutionComponent: RoutineQuestionExecutionForm<
  StatusQuestionConfig,
  StatusResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    StatusQuestionConfig,
    StatusResponseState
  >
) => {
  const fieldPrefix = `responses.${props.responseIndex}`;
  const openEndedResponseKey = `${fieldPrefix}.openEndedResponse`;
  const statusKey = `${fieldPrefix}.status`;
  const { control, setValue } = useFormContext();
  const { t } = useTranslation();
  const selectedStatus = useWatch({
    control,
    name: statusKey,
  });
  const isSelectedOpenEndedResponse = useMemo(
    () => selectedStatus === OpenEndedResponse,
    [selectedStatus]
  );

  useEffect(() => {
    if (
      (props.currentState?.state?.responses?.[props.responseIndex]?.status ===
        OpenEndedResponse ||
        props.currentState?.state?.status === OpenEndedResponse) &&
      props?.config?.openEndedResponse
    ) {
      const openEndedResponse =
        props.currentState?.state?.responses?.[props.responseIndex]
          ?.openEndedResponse ?? props.currentState?.state?.openEndedResponse;
      setValue(openEndedResponseKey, openEndedResponse, {
        shouldDirty: true,
        shouldValidate: true,
      });
      setValue(statusKey, OpenEndedResponse, {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
  }, [props.currentState]);

  if (!props.config.openEndedResponse) return null;

  const onStatusChange = (status: string) => {
    setValue(statusKey, status, { shouldDirty: true, shouldValidate: true });
  };

  return (
    <View style={{ marginTop: 20 }}>
      <TouchableOpacity
        activeOpacity={0.7}
        style={[
          styles.button,
          !isSelectedOpenEndedResponse ? styles.buttonNotSelected : {},
        ]}
        onPress={() => {
          onStatusChange(OpenEndedResponse);
        }}
        disabled={props.isIssueEditRoutine}
      >
        {isSelectedOpenEndedResponse ? (
          <ControlledTextInput
            control={control}
            name={openEndedResponseKey}
            placeholder={t('routines.status.admin.otherStatus')}
            width={'100%'}
            inputInnerStyle={styles.currentStateButton}
            backgroundColor={'transparent'}
          />
        ) : (
          <Text style={styles.buttonLabel}>
            {t('routines.status.admin.otherStatus')}
          </Text>
        )}
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  buttonsContainer: {
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  button: {
    height: 52,
    alignItems: 'center',
    justifyContent: 'center',
    color: Colors.white,
  },
  buttonNotSelected: {
    borderWidth: 2,
    borderRadius: 51,
    borderColor: Colors.blue,
  },
  currentStateButton: {
    borderWidth: 2,
    borderRadius: 51,
    borderColor: Colors.blue,
    backgroundColor: Colors.blue,
    color: Colors.white,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    width: '100%',
  },
  buttonLabel: {
    color: Colors.grayText,
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 19,
  },
  currentButtonLabel: {
    color: Colors.white,
  },
});
